import { createSlice } from "@reduxjs/toolkit";

const baseState = {
  open: false,
  message: "",
  severity: "info", // 'error' | 'warning' | 'info' | 'success'
  autoHideDuration: 6000,
  anchorOrigin: { vertical: "top", horizontal: "center" },
};

const initialState = {
  ...baseState,
};

export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      const { message, severity, autoHideDuration, anchorOrigin } =
        action.payload;
      state.open = true;
      state.message = message;
      state.severity = severity || "info";
      state.autoHideDuration = autoHideDuration || 3000;
      state.anchorOrigin = anchorOrigin || {
        vertical: "top",
        horizontal: "center",
      };
    },
    hideSnackbar: (state) => {
      state.open = false;
      state.message = "";
      state.severity = "info";
      state.autoHideDuration = 6000;
      state.anchorOrigin = { vertical: "top", horizontal: "center" };
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setSeverity: (state, action) => {
      state.severity = action.payload;
    },
    setAutoHideDuration: (state, action) => {
      state.autoHideDuration = action.payload;
    },
    setAnchorOrigin: (state, action) => {
      state.anchorOrigin = action.payload;
    },
    ResetStore: (state) => {
      state = { ...baseState };
    },
  },
});

export const {
  showSnackbar,
  hideSnackbar,
  setMessage,
  setSeverity,
  setAutoHideDuration,
  setAnchorOrigin,
  ResetStore,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
